import "./FinishedModal.scss";
import "../Popups.scss";
import { useCallback } from "react";
import Button from "components/Button/Button";
import { useAppDispatch } from "store";
import { exchangeActions } from "../../../store/reducers/exchange";
import { useTranslation } from "react-i18next";

const FinishedModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const backToCalculator = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("ExchangeCalculator"));
    const url = new URL(window.location.href);
    url.searchParams.delete("isVerificationCompleted");
    window.history.pushState({}, "", url.toString());
  }, [dispatch]);
  return (
    <div className="popup-container finished-popup">
      <div className="main-title">{t("popups.finishPopup.title")}</div>
      <div className="sub-title">{t("popups.finishPopup.description1")}</div>

      <Button btnName={t("buttons.close")} className="blue-btn" onClick={backToCalculator} />
    </div>
  );
};
export default FinishedModal;
